import { Record } from 'immutable';
import { makeReducer, match } from 'web-app/util/redux';
import * as Actions from './actions';
export class ChildrenGroupState extends Record({
    showSignedIn: false,
}) {
}
export default makeReducer([
    match(Actions.toggleWhoPicksUp, state => {
        return state.merge({
            showSignedIn: !state.showSignedIn,
        });
    }),
], new ChildrenGroupState());
